import axios from 'axios'

const state = {
  showUploadLoader: false,
  currentVendorComplianceDetails: {},   // all files belonging to vendor compliance
  selectedFile: {},
  deleteFile: {}, 			// temporarily hold selected file to delete
}

const getters = {
}

const mutations = {
  /**
   * Mutate any variable
   * @param {string}
   * @param {value}
   */
  SET_VARIABLE(state, { key, value }) {
    eval('state.' + key + ' = value');
  },

  ADD_UPLOADED_FILE(state, { files }) {
    state.currentVendorComplianceDetails.push(files);
  },
}

const actions = {
  setVariable({ commit }, { key, value }) {
    commit('SET_VARIABLE', { key: key, value: value });
  },


  // upload documents
  uploadFile({ commit, state, dispatch, rootState }, file) {

    commit('SET_VARIABLE', { key: 'showUploadLoader', value: true });

    var header = rootState.auth.header;
    var vendor_compliance_id = rootState.compliance.currentVendorCompliance.id;
    var vendor_id = rootState.compliance.currentVendorCompliance.vendor_id;

    // Build a copy so we never mutate the shared auth header, and tolerate a
    // missing headers object (axios sets the multipart boundary itself when
    // the body is a FormData).
    header = {
      ...header,
      headers: { ...(header.headers || {}), 'Content-Type': 'multipart/form-data' },
    };

    let formData = new FormData();
    formData.append('file', file);
    formData.append('vendor_compliance_id', vendor_compliance_id);

    var url = rootState.auth.l + 'v1/vendor-compliance-details';

    axios.post(url, formData, header)
      .then(response => {
        commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });

        // show file successfull upload modal
        //VueStore.dispatch('notify/setShowMessage', {key: 'showUploadFileSuccess', bool: true});
        // append new file to current list
        var newFile = response.data.data;
        //console.log(newFile);
        commit('ADD_UPLOADED_FILE', { files: newFile });

        VueStore.dispatch('compliance/getCompliancesForSidebar', vendor_id);

      }).catch((error) => {
        console.log(error);
        commit('SET_VARIABLE', { key: 'showUploadLoader', value: false });
      });
  },


  // push selected file to delete to vuex
  pushToFileDelete({ commit, state, dispatch, getters, rootState, rootGetters }, id) {
    var files = state.currentVendorComplianceDetails; // this will contain all files

    // filter by id
    var fileToDelete = files.filter(item => item.id == id);
    commit('SET_VARIABLE', { key: 'deleteFile', value: fileToDelete });
  },

  // delete file
  deleteFile({ commit, state, dispatch, getters, rootState, rootGetters }) {
    var header = rootState.auth.header;
    var deleteFile = state.deleteFile[0];
    var id = deleteFile.id;
    var vendor_id = rootState.compliance.currentVendorCompliance.vendor_id;

    // update the server
    var url = rootState.auth.l + 'v1/vendor-compliance-details/' + id;
    axios.delete(url, header)
      .then(response => {
        // show modal for successful deletion
        // VueStore.dispatch('notify/setVariable', { 
        // key: 'showDeleteVendorComplianceDetailSuccess', 
        // value: true 
        // });

        // find id of the file and remove from vuex 
        var currentVendorComplianceDetails = state.currentVendorComplianceDetails;
        var updatedVendorComplianceDetails = currentVendorComplianceDetails.filter(item => item.id != id);
        // removed the selected id to be delete and reset state variable.
        commit('SET_VARIABLE', { key: 'currentVendorComplianceDetails', value: updatedVendorComplianceDetails });

        // refresh the sidebar
        VueStore.dispatch('compliance/getCompliancesForSidebar', vendor_id);
      }).catch((error) => {
        console.log(error);
      });
  },


  getFileURL({commit, rootState}, id){
		var header = rootState.auth.header;
		var url = rootState.auth.l + 'v1/view-compliances/file?id='+id;

		axios.get(url, header).then(response => {
      commit('SET_VARIABLE', {key: 'selectedFile', value: response.data.data})

    }).catch((error) => {
			console.log(error);
		});
  
  },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}